<template>
  <div class="login-vue" :style="bg">
    <div class="container">
      <p class="title">艾罗 管理端</p>
      <div class="input-c">
        <Input prefix="ios-contact" v-model="account" placeholder="用户名" clearable @on-blur="verifyAccount" />
        <p class="error">{{accountError}}</p>
      </div>
      <div class="input-c">
        <Input type="password" v-model="pwd" prefix="md-lock" placeholder="密码" clearable @on-blur="verifyPwd" @keyup.enter.native="submit" />
        <p class="error">{{pwdError}}</p>
      </div>
      <Button :loading="isShowLoading" class="submit" type="primary" @click="submits">登陆</Button>
      <!-- <p class="account">
        <span @click="register">注册账号</span> |
        <span @click="forgetPwd">忘记密码</span>
      </p>-->
    </div>
  </div>
</template>

<script>
import { Signlogins, apimenus } from "../api/comm.js";
export default {
  name: "login",
  data() {
    return {
      account: "",
      pwd: "",
      accountError: "",
      pwdError: "",
      isShowLoading: false,
      bg: {}
    };
  },
  created() {
    this.bg.backgroundImage =
      "url(" +
      require("../assets/imgs/bg0" + new Date().getDay() + ".jpg") +
      ")";
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  methods: {
    verifyAccount() {
      if (this.account == "") {
        this.accountError = "请输入账号";
      } else {
        this.accountError = "";
      }
    },
    verifyPwd() {
      if (this.pwd == "") {
        this.pwdError = "请输入密码";
      } else {
        this.pwdError = "";
      }
    },
    register() {},
    forgetPwd() {},
    submits() {
      let key = "ailuonengyuan";
      if (this.account !== "" && this.pwd !== "") {
        // // console.log(this.encryptDes(JSON.stringify(this.account), key));
        // this.isShowLoading = true;
        // 登陆成功 设置用户信息
        // localStorage.setItem(
        //   "userImg",
        //   "https://avatars3.githubusercontent.com/u/22117876?s=460&v=4"
        // );
        // localStorage.setItem("userName", "小明XXX");
        // // 登陆成功 假设这里是后台返回的 token
        // localStorage.setItem("token", "i_am_token");
        // this.$router.push({ path: this.redirect || "/" });
        var date = {
          email: this.encryptDes(JSON.stringify(this.account), key),
          password: this.encryptDes(JSON.stringify(this.pwd), key)
        };
        // console.log(date);
        // this.isShowLoading=true
        Signlogins(date).then(res => {
          // console.log(res);
          if (res.status_code == 200) {
            localStorage.setItem("token", res.data.access_token);
            localStorage.setItem("userName", res.data.user.name);

            this.muntab();
          }
        });
      } else {
        this.$message({
          message: "请输入账号和密码",
          type: "warning"
        });
      }
    },
    muntab() {
      apimenus().then(res => {
        // console.log("菜单栏", res.data);
        if (res.status_code == 200) {
          // localStorage.setItem("muntab", res.data);
          var muntabs = [];
          muntabs.length = res.data.length;
          for (let i = 0; i < muntabs.length; i++) {
            let data = res.data[i];
            muntabs[i] = {};
            if (data.children == undefined) {
              muntabs[i].name = data.api;
            }
            muntabs[i].type = data.icon;
            muntabs[i].text = data.title;
            muntabs[i].size = 18;
            muntabs[i].hidden = false;
            if (data.children != undefined && data.children.length > 0) {
              muntabs[i].children = [];
              for (let j = 0; j < data.children.length; j++) {
                muntabs[i].children.push({
                  name: data.children[j].api,
                  type: data.children[j].icon,
                  text: data.children[j].title,
                  size: 18,
                  hidden: false
                });
              }
            }
          }
          // console.log(this.$store.state);
          this.$store.state.menuItems = muntabs;
          // this.$store.commit("setMenus", muntabs);
          localStorage.setItem("muntab", JSON.stringify(muntabs));
          this.$router.push({ path: this.redirect || "/PPuser" });
        }
      });
    }
  }
};
</script>

<style>
.login-vue {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-size: 100% 100%;
}
.login-vue .container {
  background: rgba(255, 255, 255, 0.5);
  width: 300px;
  text-align: center;
  border-radius: 10px;
  padding: 30px;
}
.login-vue .ivu-input {
  background-color: transparent;
  color: #fff;
  outline: #fff;
  border-color: #fff;
}
.login-vue ::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: rgba(255, 255, 255, 0.8);
}
.login-vue :-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(255, 255, 255, 0.8);
}
.login-vue ::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(255, 255, 255, 0.8);
}
.login-vue :-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgba(255, 255, 255, 0.8);
}
.login-vue .title {
  font-size: 16px;
  margin-bottom: 20px;
}
.login-vue .input-c {
  margin: auto;
  width: 200px;
}
.login-vue .error {
  color: red;
  text-align: left;
  margin: 5px auto;
  font-size: 12px;
  padding-left: 30px;
  height: 20px;
}
.login-vue .submit {
  width: 200px;
}
.login-vue .account {
  margin-top: 30px;
}
.login-vue .account span {
  cursor: pointer;
}
.login-vue .ivu-icon {
  color: #eee;
}
.login-vue .ivu-icon-ios-close-circle {
  color: #777;
}
</style>
